import React from "react"

import styles from "./styles.module.css"

export default ({children}) => <span className={styles.dot}>{children}</span>
